<template>
    <v-card-text>
        <v-checkbox
            color="primary"
            v-model="item.enabled"
            :label="$t('common.enabled')"
            hide-details
            single-line
        ></v-checkbox>
        <v-checkbox
            color="primary"
            v-model="item.required"
            :label="$t('common.required')"
            hide-details
            single-line
        ></v-checkbox>
        <SignaloCategoryPicker
            v-model="item.categoryPath"
            v-slot="props"
            returns="path"
            filter="planned"
        >
            <v-text-field
                variant="outlined"
                color="var(--greyscale-100)"
                :modelValue="props.text"
                @click:control="props.onClick"
                @click:clear="props.onClear"
                readonly
                clearable
                :label="$t('common.categoryOfNewIssue')"
                class="required-field"
            >
            </v-text-field>
        </SignaloCategoryPicker>

        <v-text-field
            :value="$refs?.rruleDitorPostFinish?.stringRules"
            disabled="true"
            variant="outlined"
            color="var(--greyscale-100)"
        ></v-text-field>
        <SignaloRRuleEditor
            :modelValue="item.rrule"
            @update:modelValue="
                () =>
                    (item.rrule = String(
                        $refs?.rruleDitorPostFinish?.stringRules
                    ))
            "
            :oneEntry="true"
            ref="rruleDitorPostFinish"
        />
    </v-card-text>
</template>

<script>
export default {
    props: ['modelValue'],
    data() {
        return {
            item: {
                enabled: this.modelValue?.enabled || false,
                required: this.modelValue?.required || false,
                categoryPath: this.modelValue?.categoryPath || null,
                rrule: this.modelValue?.rrule || null,
            },
        };
    },
    watch: {
        item: {
            handler(val) {
                this.$emit('update:modelValue', val);
            },
            deep: true,
        },
    },
};
</script>
